export class WarrantyItem {
  title: string;
  price: string;
  variantId: string;
  config: any;

  constructor(props: any) {
    this.title = props.title;
    this.price = props.price;
    this.variantId = props.variantId || '';
    this.config = props.config;
  }
}

export default WarrantyItem;
